import React, { useState } from "react";
import { ShoppingCart, X, Plus, Minus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export const AddToCartModal = ({ product, onClose, onAddToCart }) => {
    const [qty, setQty] = useState(product.quantity || 1);
    const [selectedImageIdx, setSelectedImageIdx] = useState(0);

    const validImages = product.images?.filter(img => img) || [];
    if(product.image_url && validImages.length === 0) validImages.push(product.image_url);
    const productImage = validImages[selectedImageIdx] || null;

    const handleAdd = () => {
        onAddToCart({ ...product, qty });
        onClose();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
            <div className="bg-white rounded-[40px] w-full max-w-lg shadow-2xl overflow-hidden relative flex flex-col max-h-[90vh] animate-in zoom-in-95 duration-500">
                <Button 
                    variant="ghost" 
                    onClick={onClose}
                    className="absolute top-4 right-4 z-10 w-12 h-12 rounded-full bg-black/5 hover:bg-black/10 transition-all text-gray-500"
                >
                    <X className="w-6 h-6" />
                </Button>

                <div className="overflow-y-auto no-scrollbar flex-1 relative">
                    <div className="h-64 bg-gray-100 relative group">
                        {productImage ? (
                            <img src={productImage} alt={product.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                        ) : (
                            <div className="w-full h-full flex items-center justify-center text-gray-300">
                                <ShoppingCart className="w-16 h-16" />
                            </div>
                        )}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none"></div>
                        <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between text-white">
                            <div>
                                <h3 className="text-3xl font-black uppercase tracking-tighter italic mb-1 leading-none">{product.title || product.name || "Pwodwi"}</h3>
                                <p className="text-sm font-bold text-gray-300 uppercase tracking-widest">{product.seller_name || "BVGLINK STORE"}</p>
                            </div>
                        </div>
                    </div>

                    <div className="p-8 space-y-8 bg-white">
                        <div className="flex items-center justify-between">
                            <Label className="text-[10px] font-black uppercase tracking-widest text-gray-400">KANTITE</Label>
                            <div className="flex items-center gap-4 bg-gray-50 p-2 rounded-2xl border border-gray-100">
                                <Button 
                                    variant="ghost" 
                                    size="sm" 
                                    onClick={() => setQty(Math.max(1, qty - 1))}
                                    className="w-10 h-10 rounded-xl font-black text-xl hover:bg-white hover:shadow-sm"
                                >-</Button>
                                <span className="w-8 text-center font-black text-xl italic">{qty}</span>
                                <Button 
                                    variant="ghost" 
                                    size="sm" 
                                    onClick={() => setQty(qty + 1)}
                                    className="w-10 h-10 rounded-xl font-black text-xl hover:bg-white hover:shadow-sm"
                                >+</Button>
                            </div>
                        </div>

                        <div className="bg-gradient-to-br from-[#232F3E] to-black rounded-[40px] p-8 text-white shadow-2xl relative overflow-hidden group">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-[#FF9900]/10 rounded-full blur-3xl -mr-16 -mt-16 group-hover:bg-[#FF9900]/20 transition-all duration-700"></div>
                            <div className="flex justify-between items-start mb-6">
                                <h4 className="flex items-center gap-3 text-xl font-black uppercase tracking-tighter italic">
                                    <ShoppingCart className="w-6 h-6 text-[#FF9900]" /> Total
                                </h4>
                                <div className="text-right">
                                    <div className="text-2xl font-black text-[#FF9900] italic">
                                        {(product.price_htg * qty).toLocaleString()} HTG
                                    </div>
                                </div>
                            </div>
                            <Button 
                                onClick={handleAdd}
                                className="w-full h-16 bg-gradient-to-r from-[#FF9900] to-[#E88B00] hover:from-[#E88B00] hover:to-[#D17D00] text-black rounded-2xl font-black text-lg uppercase tracking-tighter italic shadow-xl transition-all"
                            >
                                <Plus className="w-5 h-5 mr-2" />
                                AJOUTE NAN PANYE
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
